import { User } from '../models/user'
import { InflightPromise } from 'shared-services'
import { UserGetterService } from './user.getter-service'

export class InflightUserGetterService implements UserGetterService {
  public constructor(
    private readonly userGetterService: UserGetterService,
    private readonly inflightPromise: InflightPromise,
  ) {}

  public async getUser(): Promise<User> {
    const key = 'UserGetterService_getUser'

    if (!this.inflightPromise.isProviderRegistered(key)) {
      this.inflightPromise.registerProvider(key, () =>
        this.userGetterService.getUser(),
      )
    }

    return this.inflightPromise.unwrap(key)
  }
}
